import React from "react";
import { downloadRelatorio } from "../../services/salas";
import "./styles.css";

const Relatorios = () => {
  return (
    <div className="container">
      <h1 className="title-relatorio">Relatórios</h1>
      <div className="card">
        <h2 className="card-title">Relatório Semanal</h2>
        <button
          className="button pdf"
          onClick={() => downloadRelatorio("weekly", "pdf")}
        >
          Baixar PDF
        </button>
        <button
          className="button excel"
          onClick={() => downloadRelatorio("weekly", "excel")}
        >
          Baixar Excel
        </button>
      </div>
      
      <div className="card">
        <h2 className="card-title">Relatório Mensal</h2>
        <button
          className="button pdf"
          onClick={() => downloadRelatorio("monthly", "pdf")}
        >
          Baixar PDF
        </button>
        <button
          className="button excel"
          onClick={() => downloadRelatorio("monthly", "excel")}
        >
          Baixar Excel
        </button>
      </div>
    </div>
  );
};

export default Relatorios;